export default __webpack_public_path__ + "static/media/81.0b406b63.png";